// desc 限制数字长度
export const CHECK_num_length = (limitLength) => new RegExp(`^\\d{${limitLength}}$`);
// desc 限制数字长度范围
export const CHECK_num_range = (begin = 0, end) => new RegExp(`^\\d{${begin},${end}}$`);
// desc 限制至多7位数字
export const CHECK_Money = CHECK_num_range(0, 7);
// desc 限制至多7位整百数字
export const CHECK_Money7 = new RegExp('^(0|[1-9]{1}[0-9]{0,4}[0]{2})$');
// desc 正数（可有一位小数）不可为0
export const CHECK_Num = new RegExp('^(([0][.][1-9])|([1-9]([0-9]+)?([.][0-9]{1})?))$');
export const CHECK_Num2 = new RegExp('^(([0][.][0-9]{1,2})|([1-9]([0-9]{0,2})?([.][0-9]{1,2})?))$');
// desc 手机号 - 11位数字
export const CHECK_phone = CHECK_num_length(11);
// desc 身份证号-18位纯数字或【17位数字X】或【17位数字x】
export const CHECK_idCard = /^\d{17}[0-9Xx]$/;
// desc 限制百分比
export const CHECK_percent = /^([1-9]?\d|100)$/;
// desc 买家号码牌 3位数字（排除000）
export const CHECK_buyerCode = /^\d{1,3}$/;
export const CHECK_phonebuyerCode = /^(\d{1,3}|\d{11})$/;
// desc 数字 大于0小于1000的整数（不含0）
export const CHECK_number1 = /^[1-9]{1}[0-9]{0,2}$/;
// desc 数字 小于1000的正整数（含0）
export const CHECK_number2 = /^[0-9]{0,3}$/;
// desc 是否是URL
export const CHECK_URL = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
// desc 限制字符长度（不限制中英文）
export const CHECK_name = function (limitLength) {
    return function (rule, value, callback) {
        const dealVal = value ? value.replace(/[\u4e00-\u9fa5]/g, 'aa') : '';
        if (dealVal.length > limitLength) {
            callback(`不可超过${limitLength / 2}字`);
        }
        else {
            callback();
        }
    };
};
/**
 * 输入金额检查
 * required:      false   ===> 是否必填
 * type:          hundred ===> 输入的必须是整百
 * maxVal:        maxVal  ===> 输入的最大金额
 * includeZero:   includeZero  ===> 是否可以输入0
 * @param {string} type
 * @param {boolean} required
 * @param {number} maxVal
 * @param {boolean} includeZero
 * @returns {(rule: any, value: number, callback: any) => undefined}
 * @constructor
 */
export const CHECK_MONEY = function (required = false, type, maxVal = 9999999, includeZero = false) {
    return function (rule, value, callback) {
        if (!required && !value || value === '自定义') {
            callback();
        }
        else if (includeZero && Number(value) === 0 && value !== '') {
            callback();
        }
        else if (!Number(value)) {
            callback('请输入合法金额');
        }
        else if (value >= maxVal || value < 0) {
            callback(`请输入0-${maxVal}之间的金额`);
        }
        else if (type === 'hundred' && value > 0 && value % 100) {
            callback('请输入整百金额');
        }
        else if (type !== 'hundred' && !CHECK_FLOAT_WITH_NUM.test(value)) {
            callback('请输入不超过两位小数的正数');
        }
        else {
            callback();
            return;
        }
    };
};
/**
 * 检验输入是否为正百金额
 * @param {boolean} canZero 是否可以输入0
 * @returns {(rule: any, value: any, callback: any) => undefined}
 * @constructor
 */
export const CHECK_MONEY_HUNDRED = function (canZero = false) {
    return function (rule, value, callback) {
        if (value > 9999999) {
            callback('请输入7位整数');
        }
        else if (value !== '' && !canZero && Number(value) === 0) {
            callback('请输入非0整百金额');
        }
        else if (value % 100 !== 0) {
            callback('请输入整百金额');
        }
        else {
            callback();
            return;
        }
    };
};
// desc 限制只能输入字母a-Z以及数字
export const CHECK_num_letter = /^[0-9A-Za-z]+$/;
export function CHECK_num_letter_range(limitLength) {
    return new RegExp(`^[0-9A-Za-z]{0,${limitLength}}$`);
}
export const Hundred_Money = function () {
    return function (rule, value, callback) {
        if (value > 9999999) {
            callback('请输入7位整数');
        }
        if (value % 100 === 0) {
            callback();
        }
        else {
            callback('请输入整百金额');
        }
    };
};
/**
 * 校验数据的经纬度是否合法
 */
export const CHECK_Coordinate = function () {
    return function (rule, value, callback) {
        if (value.trim()) {
            if (value.indexOf(',') != -1) {
                const longitudeReg = /^[\-\+]?(0?\d{1,2}|0?\d{1,2}\.\d{1,15}|1[0-7]?\d{1}|1[0-7]?\d{1}\.\d{1,15}|180|180\.0{1,15})$/;
                const latitudeReg = /^[\-\+]?([0-8]?\d{1}|[0-8]?\d{1}\.\d{1,15}|90|90\.0{1,15})$/;
                // 经度
                const longitude = value.split(',')[0];
                // 纬度
                const latitude = value.split(',')[1];
                if (!longitudeReg.test(longitude)) {
                    callback('请输入合法的经度, 经度范围 -180 - 180');
                }
                if (!latitudeReg.test(latitude)) {
                    callback('请输入合法的纬度, 纬度范围 -90 - 90');
                }
                callback();
            }
            callback('经度范围-180 - 180, 纬度范围-90 - 90,且用英文逗号分割');
        }
        callback('请输入坐标值');
    };
};
/**
 * 验证数据是否大于某个值
 * @param {number} maxVal
 * @param {string} tip
 * @returns {(rule: any, value: any, callback: any) => undefined}
 * @constructor
 */
export const CHECK_VALUE_RANGE = function (maxVal, tip = `最大不应超过${maxVal}`) {
    return function (rule, value, callback) {
        if (Number(value) > Number(maxVal)) {
            callback(tip);
        }
        else {
            callback();
            return;
        }
    };
};
// desc 输入正整数
export const CHECK_VALUE_INTEGER = /^[0-9]*[1-9][0-9]*$/;
// desc 输入 0 和正小数(1位)
export const CHECK_FLOAT_INCLUDE_ZERO = /^(0|^(([0][.][0-9])|([1-9]([0-9]+)?([.][0-9]{1})?))$)$/;
// desc 正小数(1位) 且不能为0
export const CHECK_FLOAT_NO_ZERO = /^(^(([0][.][1-9])|([1-9]([0-9]+)?([.][0-9]{1})?))$)$/;
// desc 正整数 整小数(不超过2位) 不可为0
export const CHECK_FLOAT_WITH_NUM = /^(([1-9][0-9]*)|([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2}))$/;
// desc 正整数 最多n(默认6)位 不能为 0
export const CHECK_VALUE_INTEGER_MAXVAL_NO_ZERO = /^[1-9]\d{0,5}$/;
/**
 * 百分比检查
 * required： 是否必填
 * canInputZeroHundred： 能否输入0和100
 * @param {boolean} required
 * @param {boolean} canInputZeroHundred
 * @returns {(rule: any, value: any, callback: any) => undefined}
 * @constructor
 */
export const CHECK_PERCENT = function (required = true, canInputZeroHundred = true) {
    // desc 百分比 (不包括 0 和 100)
    const PERCENT_NO_ZERO_HUNDRED = /^([1-9]\d?)$/;
    // desc 百分比 (包括 0 和 100)
    const PERCENT_YES_ZERO_HUNDRED = /^([1-9]?\d|100)$/;
    return function (rule, value, callback) {
        if (!required && !value) {
            callback();
        }
        else if (!canInputZeroHundred && !PERCENT_NO_ZERO_HUNDRED.test(value)) {
            callback('请输入1-99正整数');
        }
        else if (canInputZeroHundred && !PERCENT_YES_ZERO_HUNDRED.test(value)) {
            callback('请输入0-100正整数');
        }
        else {
            callback();
            return;
        }
    };
};
